import React from 'react'
import { Card, CardHeader, CardBody } from 'reactstrap'
import { Buttons } from './buttons'
import { PageTitle } from 'components/pageTitle'
import { useStyles } from './page.css'

const Page = React.memo(({ renderAtTop, title, persistor, ...props }) => {
  const classes = useStyles()
  const renderAtTopFn = React.useCallback(() => typeof renderAtTop === 'function' ? renderAtTop() : null, [renderAtTop])

  const { metadata, hideGoBack, loading, titleButtons, children, isTrash } = props
  
  return (
    <Card className={`${classes.root} ${isTrash ? 'is-trash': ''}`}>
      <CardHeader>
        <PageTitle title={title} metadata={metadata} hideGoBack={hideGoBack} loading={loading} buttons={titleButtons} />
      </CardHeader>
      <CardBody className={classes.body}>
        {renderAtTopFn()}
        <Buttons {...props} classes={classes} />
        {children}
      </CardBody>
    </Card>
  )
})

export default Page